<template>
    <div>
        <financialDashboard v-if="session.group.key.includes('ROLE_SUPERADMIN','ROLE_ADMIN', 'ROLE_RESELLER')"/>
        <terminalDashboard v-if="session.group.key.includes('ROLE_TERMINAL')"/>
    </div>
  </template>
  
  <script>
  import financialDashboard from '@/components/dashboard/financial'
  import terminalDashboard from '@/components/dashboard/terminal'
  export default {
    name: 'Dashboard',
    components: {financialDashboard,terminalDashboard},
    data () {
      return {
        session: this.$root.session
      }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/components/dashboard/Page.vue